import { useRequestTenantAccountSettingsQuery } from '@/core/services/SettingsManagement.service';

interface SubscriptionSwitchPolicy {
  /**
   * Whether the "switch immediately" option is offered. Driven by the operator setting
   * (BUS-2482): `user.accounts` → `subscriptions.allowImmediateSwitch`. When false, only
   * next-renewal switching is shown. Defaults to allowed when the setting is absent.
   */
  allowImmediateSwitch: boolean;
  /** True while the operator setting is still loading (don't act on the default yet). */
  isLoading: boolean;
}

const useSubscriptionSwitchPolicy = (): SubscriptionSwitchPolicy => {
  const { data: setting, isLoading } = useRequestTenantAccountSettingsQuery();

  return {
    allowImmediateSwitch: setting?.value?.subscriptions?.allowImmediateSwitch ?? true,
    isLoading,
  };
};

export default useSubscriptionSwitchPolicy;
